import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
  Spinner,
} from 'reactstrap';
import usePatch from '../../helpers/hooks/usePatch';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import _ from 'lodash';
const CcrDetails = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [ccr, ccrLoading] = useGet(`/ccrs/${id}`,true);
  const [postCcr, postedData, postingError, dataPosting] = usePatch(
    `/ccrs/${id}`
  );

//   const handleToggler = (farmer, packages) => {
//     postFarmer({ packages }, `/farmers/${farmer.id}`).then((e) =>
//       loadFarmers()
//     );
//   };

const handleFormSubmit = (event, errors, values) => {
  console.log("HELLOOOOO==>>", values);
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }
   
 
    const obj = _.omit(
      {
        ...values,
      },
      values.password.length === 0 && 'password'
    );
      postCcr({...obj});
    
  };

  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    console.log(ccr?.isActive);
    if (postedData) {
      toastr.success('Ccr has been updated successfully');
      history.push('/users/ccr');
    }
  }, [history, postedData]);

  
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit Ccr</h4>
                <Card>
                  <CardBody>
                    {ccrLoading ? (
                      <div className='text-center'>
                        <Spinner className='mr-2' color='primary' />
                      </div>
                    ) : (
                      <>
                        <Row>
                          <Col >
                            <FormGroup>
                              <Label htmlFor='fname'>FirstName</Label>
                              <AvField
                              name='firstName'
                              placeholder='First Name'
                              type='text'
                              errorMessage='Enter Your First Name'
                              className='form-control'
                              validate={{ required: { value: true } }}
                              id='lastName'
                              value={ccr?.firstName}
                            />
                            </FormGroup>
                          </Col>
                        </Row>
                          <Row>
                          <Col >
                          <FormGroup>
                            <Label htmlFor='lname'>LastName</Label>
                            <AvField
                              name='lastName'
                              placeholder='Last Name'
                              type='text'
                              errorMessage='Enter Your Last Name'
                              className='form-control'
                              validate={{ required: { value: true } }}
                              id='lastName'
                              value={ccr?.lastName}
                            />
                          </FormGroup>
                        </Col>
                        </Row>
                         
                        <Row>
                          <Col >
                            <FormGroup>
                            <Label htmlFor='email'>Email</Label>
                            <AvField
                              name='email'
                              placeholder='Email'
                              type='email'
                              errorMessage='Enter Your Email'
                              className='form-control'
                              validate={{ required: { value: true } }}
                              id='email'
                              value={ccr?.email}
                            />
                            </FormGroup>
                          </Col> 
                        </Row>
                        <div className='d-flex'>
                          <Label className='mr-3'>Ccr Active?</Label>
                          <AvField
                            name='isActive'
                            placeholder="check"
                            type='checkbox'
                            validate={{
                              required: { value: false },
                            }}
                            id='isActive'
                            checked={ccr?.isActive? true: false}
                            // value={ccr?.isActive}
                          />
                        </div>

                        <div className='border mb-3 mt-2'></div>
                        <FormGroup>
                          <Label htmlFor='password'>Change Password</Label>
                          <AvField
                            name='password'
                            placeholder='Password'
                            type='text'
                            errorMessage='Minimun length required is 5'
                            className='form-control'
                            validate={{
                              minLength: { value: 5 },
                            }}
                            id='password'
                          />
                        </FormGroup>
                      </>
                    )}
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting}
                  >
                    {dataPosting 
                      ? 'Saving...'
                      : 'Update Ccr'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default CcrDetails;
